<template>
  <v-container fluid class="admin-package">
    <v-tabs v-model="tabIndex">
      <v-tab>{{ $t('admin_acc_package_page.title') }}</v-tab>
      <v-tab-item>
        <PackageListingPageSettings v-if="tabIndex === 0"></PackageListingPageSettings>
      </v-tab-item>

      <v-tab>{{ $t('admin_acc_package_type.title') }}</v-tab>
      <v-tab-item>
        <v-row class="flex-grow-0">
          <v-col class="text-right">
            <v-btn color="primary"
                   @click="addPackageTypeModalShown = true">
              {{ $t('admin_acc_package_type.add_title') }}
            </v-btn>
          </v-col>
        </v-row>
        <AdminPackageTypeList full-height
                              :refresh-trigger.sync="packageTypeRefreshTrigger"
                              @edit="onPackageTypeEdit"
                              @package="onPackageTypeShowPurchaseRecord"
                              v-if="tabIndex === 1"></AdminPackageTypeList>

        <AddPackageTypeModal :shown="addPackageTypeModalShown"
                             @cancel="addPackageTypeModalShown = false"
                             @finish="onAddPackageTypeModalFinish"></AddPackageTypeModal>

        <EditPackageTypeModal :shown="editPackageTypeModalShown"
                              :package-type-id="editingPackageTypeId"
                              @cancel="editPackageTypeModalShown = false"
                              @finish="onEditPackageTypeModalFinish"></EditPackageTypeModal>

        <PackageTypePurchaseRecordModal :shown="packageTypePurchaseRecordModalShown"
                                        :package-type-id="showingPurchaseRecordPackageTypeId"
                                        @cancel="packageTypePurchaseRecordModalShown = false"></PackageTypePurchaseRecordModal>
      </v-tab-item>

      <v-tab>{{ $t('admin_acc_package.title') }}</v-tab>
      <v-tab-item>
        <AdminPackagePurchaseRecordList full-height
                                        :refresh-trigger.sync="packageRefreshTrigger"
                                        @edit="onPackageEdit"
                                        v-if="tabIndex === 2"></AdminPackagePurchaseRecordList>
      </v-tab-item>
    </v-tabs>
  </v-container>

</template>

<script>
import {ref} from '@vue/composition-api';
import AdminPackageTypeList from "@/components/package/AdminPackageTypeList";
import AddPackageTypeModal from "@/components/package/AddPackageTypeModal";
import EditPackageTypeModal from "@/components/package/EditPackageTypeModal";
import AdminPackagePurchaseRecordList from "@/components/package/AdminPackagePurchaseRecordList";
import PackageTypePurchaseRecordModal from "@/components/package/PackageTypePurchaseRecordModal";
import PackageListingPageSettings from "@/components/package/PackageListingPageSettings";

export default {
  name: 'Package',
  components: {PackageListingPageSettings, PackageTypePurchaseRecordModal, AdminPackagePurchaseRecordList, EditPackageTypeModal, AddPackageTypeModal, AdminPackageTypeList},
  setup(props, {root, emit}) {
    const tabIndex = ref(0);

    // Package Type
    const packageTypeRefreshTrigger = ref(false);
    const refreshPackageType = function () {
      packageTypeRefreshTrigger.value = !packageTypeRefreshTrigger.value;
    };

    const addPackageTypeModalShown = ref(false);
    const onAddPackageTypeModalFinish = function (item) {
      addPackageTypeModalShown.value = false;
      refreshPackageType();
    }

    const editingPackageTypeId = ref(null);
    const editPackageTypeModalShown = ref(false);
    const onPackageTypeEdit = function (item) {
      editingPackageTypeId.value = item.id;
      editPackageTypeModalShown.value = true;
    };
    const onEditPackageTypeModalFinish = function () {
      editPackageTypeModalShown.value = false;
      refreshPackageType();
    }

    // Package
    const packageRefreshTrigger = ref(false);
    const refreshPackage = function () {
      packageRefreshTrigger.value = !packageRefreshTrigger.value;
    };

    const editingPackageId = ref(null);
    const editPackageModalShown = ref(false);
    const onPackageEdit = function (item) {
      editingPackageId.value = item.id;
      editPackageModalShown.value = true;
    };
    const onEditPackageModalFinish = function () {
      editPackageModalShown.value = false;
      refreshPackage();
    }

    const packageTypePurchaseRecordModalShown = ref(false);
    const showingPurchaseRecordPackageTypeId = ref(null);
    const onPackageTypeShowPurchaseRecord = function (item) {
      showingPurchaseRecordPackageTypeId.value = item.id;
      packageTypePurchaseRecordModalShown.value = true;
    };

    return {
      tabIndex,

      packageTypeRefreshTrigger,
      refreshPackageType,

      addPackageTypeModalShown,
      onAddPackageTypeModalFinish,

      editingPackageTypeId,
      editPackageTypeModalShown,
      onPackageTypeEdit,
      onEditPackageTypeModalFinish,

      //
      packageRefreshTrigger,
      refreshPackage,

      editingPackageId,
      editPackageModalShown,
      onPackageEdit,
      onEditPackageModalFinish,

      packageTypePurchaseRecordModalShown,
      showingPurchaseRecordPackageTypeId,
      onPackageTypeShowPurchaseRecord,
    }
  },
}
</script>

<style lang="less">
.admin-package {
  height: 100%;
  display: flex;
  flex-direction: column;

  .v-tabs {
    height: 100%;

    .v-tabs-bar {
      flex: 0 0 auto;
    }

    .v-tabs-items {
      height: calc(100% - 48px);
      flex: 1 1 0;

      .v-window__container {
        height: 100% !important;

        .v-window-item {
          height: 100% !important;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
